"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1317],{

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ applyFnToProps; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Applies a function to properties of a specified type in an object, recursively.
 *
 * @param {Object} obj - The object to apply the function to.
 * @param {Function} fn - The function to apply to matching properties.
 * @param {string} [type='string'] - The type of properties to apply the function to.
 * @param {Array<string>} [ignoreKeys=[]] - The keys of properties to ignore and not modify.
 * @returns {Object} - The object with function recursively applied.
 */
function applyFnToProps(obj, fn, type = 'string', ignoreKeys = []) {
  if (!obj || typeof obj !== 'object') return obj;
  Object.keys(obj).forEach(property => {
    if (typeof obj[property] === 'object') {
      applyFnToProps(obj[property], fn, type, ignoreKeys);
    } else {
      // eslint-disable-next-line valid-typeof
      if (typeof obj[property] === type && !ignoreKeys.includes(property)) obj[property] = fn(obj[property]);
    }
  });
  return obj;
}

/***/ }),

/***/ 6432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/aggregate/canonical-function-name.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const canonicalFunctionNameRe = /([a-z0-9]+)$/i;

/**
 * Given a function name string, extracts only an alphanumeric segment at the end of the string (if one exists).
 * This is useful for stack traces, where functions might not be named (e.g., anonymous, computed).
 *
 * @param {string} functionNameString - The original function name string.
 * @returns {string|undefined} The canonical function name, or undefined if the input is falsy or no alphanumeric segments are found.
 */
function canonicalFunctionName(functionNameString) {
  if (!functionNameString) return;
  const match = functionNameString.match(canonicalFunctionNameRe);
  if (match) return match[1];
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/aggregate/format-stack-trace.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

var stripNewlinesRegex = /^\n+|\n+$/g;
var MAX_STACK_TRACE_LENGTH = 65530;
function formatStackTrace(stackLines) {
  return truncateStackLines(stackLines).replace(stripNewlinesRegex, '');
}

// takes array of stack lines and returns string with top 50 and buttom 50 lines
function truncateStackLines(stackLines) {
  var stackString;
  if (stackLines.length > 100) {
    var truncatedLines = stackLines.length - 100;
    stackString = stackLines.slice(0, 50).join('\n');
    stackString += '\n< ...truncated ' + truncatedLines + ' lines... >\n';
    stackString += stackLines.slice(-50).join('\n');
  } else {
    stackString = stackLines.join('\n');
  }
  return stackString;
}

// truncates stack string to limit what is sent to backend
function truncateSize(stackString) {
  return stackString.length > MAX_STACK_TRACE_LENGTH ? stackString.substr(0, MAX_STACK_TRACE_LENGTH) : stackString;
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/clean-url.js
var clean_url = __webpack_require__(1478);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/canonicalize-url.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




/**
 * Converts a URL to its basic form without a query string or fragment. If the resulting URL is the same as the
 * loader's origin URL, returns '<inline>'.
 * @param {string} url - The URL to be canonicalized.
 * @param {string} loaderOriginUrl - The origin URL of the agent loader, used for inline detection.
 * @returns {string} The canonicalized URL, or '<inline>' if the URL matches the loader origin URL.
 */
function canonicalizeUrl(url) {
  if (typeof url !== 'string') return '';
  const cleanedUrl = (0,clean_url/* cleanURL */.f)(url);
  const cleanedGlobalScopeUrl = (0,clean_url/* cleanURL */.f)(runtime/* initialLocation */.FN);

  // If the URL matches the origin URL of the loader, we assume it originated within an inline script.
  if (cleanedUrl === cleanedGlobalScopeUrl) {
    return '<inline>';
  } else {
    return cleanedUrl;
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/aggregate/compute-stack-trace.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/* eslint-disable no-useless-escape */

// computeStackTrace: cross-browser stack traces in JavaScript
//
// Syntax:
//   s = computeStackTrace(exception) // consider using TraceKit.report instead
// Returns:
//   s.name              - exception name
//   s.message           - exception message
//   s.stack[i].url      - JavaScript or HTML file URL
//   s.stack[i].func     - function name, or empty for anonymous functions
//   s.stack[i].line     - line number, if known
//   s.stack[i].column   - column number, if known
//   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
//   s.mode              - 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace
//
// Supports:
//   - Firefox:  full stack trace with line numbers and unreliable column
//               number on top frame
//   - Chrome:   full stack trace with line and column numbers
//   - Safari:   line and column number for the topmost stacktrace element
//               only
//   - IE:       no line numbers whatsoever

// Contents of Exception in various browsers.
//
// SAFARI:
// ex.message = Can't find variable: qq
// ex.line = 59
// ex.sourceId = 580238192
// ex.sourceURL = http://...
// ex.expressionBeginOffset = 96
// ex.expressionCaretOffset = 98
// ex.expressionEndOffset = 98
// ex.name = ReferenceError
//
// FIREFOX:
// ex.message = qq is not defined
// ex.fileName = http://...
// ex.lineNumber = 59
// ex.stack = ...stack trace... (see the example below)
// ex.name = ReferenceError
//
// CHROME:
// ex.message = qq is not defined
// ex.name = ReferenceError
// ex.type = not_defined
// ex.arguments = ['aa']
// ex.stack = ...stack trace...
//
// INTERNET EXPLORER:
// ex.message = ...
// ex.name = ReferenceError


var debug = false;
var classNameRegex = /function (.+?)\s*\(/;
var chrome = /^\s*at (?:((?:\[object object\])?(?:[^(]*\([^)]*\))*[^()]*(?: \[as \S+\])?) )?\(?((?:file|http|https|chrome-extension):.*?)?:(\d+)(?::(\d+))?\)?\s*$/i;
var gecko = /^\s*(?:(\S*|global code)(?:\(.*?\))?@)?((?:file|http|https|chrome|safari-extension).*?):(\d+)(?::(\d+))?\s*$/i;
var chromeEval = /^\s*at .+ \(eval at \S+ \((?:(?:file|http|https):[^)]+)?\)(?:, [^:]*:\d+:\d+)?\)$/i;
var ieEval = /^\s*at Function code \(Function code:\d+:\d+\)\s*/i;

/**
 * Represents an error with a stack trace.
 * @typedef {Object} StackInfo
 * @property {string} name - The name of the error (e.g. 'TypeError').
 * @property {string} message - The error message.
 * @property {string} stackString - The stack trace as a string.
 * @property {Array<Object>} frames - An array of frames in the stack trace.
 * @property {string} frames.url - The URL of the file containing the code for the frame.
 * @property {string} frames.func - The name of the function associated with the frame.
 * @property {number} frames.line - The line number of the code in the frame.
 */

/**
 * Attempts to compute a stack trace for the given exception.
 * @param {Error} ex - The exception for which to compute the stack trace.
 * @returns {StackInfo} A stack trace object containing information about the frames on the stack.
 */
function computeStackTrace(ex) {
  var stack = null;
  try {
    stack = computeStackTraceFromStackProp(ex);
    if (stack) {
      return stack;
    }
  } catch (e) {
    if (debug) {
      throw e;
    }
  }
  try {
    stack = computeStackTraceBySourceAndLine(ex);
    if (stack) {
      return stack;
    }
  } catch (e) {
    if (debug) {
      throw e;
    }
  }
  try {
    stack = computeStackTraceWithMessageOnly(ex);
    if (stack) {
      return stack;
    }
  } catch (e) {
    if (debug) {
      throw e;
    }
  }
  return {
    mode: 'failed',
    stackString: '',
    frames: []
  };
}

/**
 * Computes stack trace information from the stack property. Chrome and Gecko use this property.
 *
 * @param {Error} ex - The error object to compute the stack trace for.
 * @return {?Object.<string, *>} Stack trace information.
 */
function computeStackTraceFromStackProp(ex) {
  if (!ex.stack) {
    return null;
  }
  var errorInfo = ex.stack.split('\n').reduce(parseStackProp, {
    frames: [],
    stackLines: [],
    wrapperSeen: false
  });
  if (!errorInfo.frames.length) return null;
  return {
    mode: 'stack',
    name: ex.name || getClassName(ex),
    message: ex.message,
    stackString: formatStackTrace(errorInfo.stackLines),
    frames: errorInfo.frames
  };
}

/**
 * Parses a line from a JavaScript error stack trace and adds it to the given `info` object.
 * Ignores all stack entries thrown from one of our wrapper functions.
 *
 * @param {object} info - The `info` object to add the parsed line to.
 * @param {string} line - The line to parse.
 * @returns {object} The `info` object with the parsed line added.
 */
function parseStackProp(info, line) {
  let element = getStackElement(line);

  // This catches lines that aren't frames (like the first line stating the error).
  if (!element) {
    info.stackLines.push(line);
    return info;
  }

  // Once we've seen a wrapper, ignore all subsequent stack entries.
  if (isNrWrapper(element.func)) info.wrapperSeen = true;
  if (!info.wrapperSeen) {
    // Query strings and fragments should be removed, and URLs matching the loader's origin should be "<inline>".
    let canonicalUrl = canonicalizeUrl(element.url);
    if (canonicalUrl !== element.url) {
      line = line.replace(element.url, canonicalUrl);
      element.url = canonicalUrl;
    }
    info.stackLines.push(line);
    info.frames.push(element);
  }
  return info;
}

/**
 * Parses a line from a JavaScript error stack trace to extract information about a stack trace element, such as the
 * URL, function name, line number, and column number.
 *
 * @param {string} line - A single line from a JavaScript error stack trace.
 * @returns {object} An object containing information about the stack trace element, including the URL, function
 *     name, line number, and column number (if available).
 */
function getStackElement(line) {
  var parts = line.match(gecko);
  if (!parts) parts = line.match(chrome);
  if (parts) {
    return {
      url: parts[2],
      func: parts[1] !== 'Anonymous function' && parts[1] !== 'global code' && parts[1] || null,
      line: +parts[3],
      column: parts[4] ? +parts[4] : null
    };
  }
  if (line.match(chromeEval) || line.match(ieEval) || line === 'anonymous') {
    return {
      func: 'evaluated code'
    };
  }
}

/**
 * Computes a stack trace object from an error object, by extracting the source and line number from the error object,
 * and using them to create a single stack frame.
 *
 * @param {Error} ex - The error object to compute the stack trace for.
 * @returns {Object|null} - An object representing the computed stack trace, or null if the
 * input error object does not contain a line number.
 */
function computeStackTraceBySourceAndLine(ex) {
  if (!('line' in ex)) return null;
  var className = ex.name || getClassName(ex);

  // Safari does not provide a URL for errors in eval'd code
  if (!ex.sourceURL) {
    return {
      mode: 'sourceline',
      name: className,
      message: ex.message,
      stackString: className + ': ' + ex.message + '\n    in evaluated code',
      frames: [{
        func: 'evaluated code'
      }]
    };
  }

  // Remove any query string and fragment
  var canonicalUrl = canonicalizeUrl(ex.sourceURL);
  var stackString = className + ': ' + ex.message + '\n    at ' + canonicalUrl;
  if (ex.line) {
    stackString += ':' + ex.line;
    if (ex.column) {
      stackString += ':' + ex.column;
    }
  }
  return {
    mode: 'sourceline',
    name: className,
    message: ex.message,
    stackString,
    frames: [{
      url: canonicalUrl,
      line: ex.line,
      column: ex.column
    }]
  };
}

/**
 * For exceptions with no stack and only a message, derives a stack trace by extracting the class name and message.
 *
 * @param {Error} ex - The exception for which to compute the stack trace.
 * @returns {StackTrace} A stack trace object containing the name and message of the exception.
 */
function computeStackTraceWithMessageOnly(ex) {
  var className = ex.name || getClassName(ex);
  if (!className) return null;
  return {
    mode: 'nameonly',
    name: className,
    message: ex.message,
    stackString: className + ': ' + ex.message,
    frames: []
  };
}

/**
 * Attempts to extract the name of the constructor function (the class) of the given object.
 *
 * @param {Object} obj - The object for which to extract the constructor function name.
 * @returns {string} The name of the constructor function, or 'unknown' if the name cannot be determined.
 */
function getClassName(obj) {
  var results = classNameRegex.exec(String(obj.constructor));
  return results && results.length > 1 ? results[1] : 'unknown';
}

/**
 * Checks whether the given function name is a New Relic wrapper function.
 *
 * @param {string} functionName - The name of the function to check.
 * @returns {boolean} True if the function name includes the string 'nrWrapper', false otherwise.
 */
function isNrWrapper(functionName) {
  return functionName && functionName.indexOf('nrWrapper') >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/aggregate/string-hash-code.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

function stringHashCode(string) {
  var hash = 0;
  var charVal;
  if (!string || !string.length) return hash;
  for (var i = 0; i < string.length; i++) {
    charVal = string.charCodeAt(i);
    hash = (hash << 5) - hash + charVal;
    hash = hash | 0; // Convert to 32bit integer
  }
  return hash;
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/handle.js
var handle = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/constants.js
var constants = __webpack_require__(6067);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/now.js
var now = __webpack_require__(1595);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/traverse.js
var traverse = __webpack_require__(3403);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/aggregate/internal-errors.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
const REASON_RRWEB = 'Rrweb';
const REASON_SECURITY_POLICY = 'Security-Policy';
/**
 * This function is responsible for determining if an error should be swallowed or not.
 * @param {Object} stackInfo - The error stack information.
 * @returns {boolean} - Whether the error should be swallowed or not.
 */
function evaluateInternalError(stackInfo, internal, reason) {
  const output = {
    shouldSwallow: internal || false,
    reason: reason || 'Other'
  };
  const leadingFrame = stackInfo.frames?.[0];
  /** If we cant otherwise determine from the frames and message, the default of internal + reason will be the fallback */
  if (!leadingFrame || typeof stackInfo?.message !== 'string') return output;

  // check if the error happened in expected modules or if messages match known patterns
  const isNrRecorder = leadingFrame?.url?.match(/nr-(.*)-recorder.min.js/);
  const isRrweb = leadingFrame?.url?.match(/rrweb/);
  const isMaybeNrRecorder = leadingFrame?.url?.match(/recorder/);
  const isSecurityPolicyAPIError = stackInfo.message.toLowerCase().match(/an attempt was made to break through the security policy of the user agent/);

  // check if modules and patterns above fit known swallow cases
  if (!!isNrRecorder || !!isRrweb) {
    /** We know -for sure- that the error came from our recorder module or rrweb directly if these are true, so swallow it */
    output.shouldSwallow = true;
    output.reason = REASON_RRWEB;
    if (isSecurityPolicyAPIError) output.reason += '-' + REASON_SECURITY_POLICY;
  } else if (!!isMaybeNrRecorder && isSecurityPolicyAPIError) {
    /** We -suspect- that the error came from NR, so if it matches the exact case we know about, swallow it */
    output.shouldSwallow = true;
    output.reason = REASON_RRWEB + '-' + REASON_SECURITY_POLICY;
  }
  // other swallow conditions could also be added here
  return output;
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/jserrors/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
















/**
 * @typedef {import('./compute-stack-trace.js').StackInfo} StackInfo
 */

class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t;
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t);
    this.stackReported = {};
    this.observedAt = {};
    this.pageviewReported = {};
    this.bufferedErrorsUnderSpa = {};
    this.errorOnPage = false;

    // this will need to change to match whatever ee we use in the instrument
    this.ee.on('interactionDone', (interaction, wasSaved) => this.onInteractionDone(interaction, wasSaved));
    (0,register_handler/* registerHandler */.X)('err', (...args) => this.storeError(...args), this.featureName, this.ee);
    (0,register_handler/* registerHandler */.X)('ierr', (...args) => this.storeError(...args), this.featureName, this.ee);
    (0,register_handler/* registerHandler */.X)('softNavFlush', (interactionId, wasFinished, softNavAttrs) => this.onSoftNavNotification(interactionId, wasFinished, softNavAttrs), this.featureName, this.ee); // when an ixn is done or cancelled

    this.harvestOpts.aggregatorTypes = ['err', 'ierr', 'xhr']; // the types in EventAggregator this feature cares about

    // 0 == off, 1 == on
    this.waitForFlags(['err']).then(([errFlag]) => {
      if (errFlag) {
        this.drain();
      } else {
        this.blocked = true; // if rum response determines that customer lacks entitlements for spa endpoint, this feature shouldn't harvest
        this.deregisterDrain();
      }
    });
  }
  serializer(aggregatorTypeToBucketsMap) {
    return (0,traverse/* applyFnToProps */.R)(aggregatorTypeToBucketsMap, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string');
  }
  queryStringsBuilder(aggregatorTakeReturnedData) {
    const qs = {};
    const releaseIds = (0,stringify/* stringify */.P)(this.agentRef.runtime.releaseIds);
    if (releaseIds !== '{}') qs.ri = releaseIds;
    if (aggregatorTakeReturnedData?.err?.length) {
      if (!this.errorOnPage) {
        qs.pve = '1';
        this.errorOnPage = true;
      }
      // For assurance, erase any `hasReplay` flag from all errors if replay is not recording, not-yet imported, or not running at all.
      if (!this.agentRef.features?.[features/* FEATURE_NAMES.sessionReplay */.DT.sessionReplay]?.featAggregate?.replayIsActive()) aggregatorTakeReturnedData.err.forEach(error => delete error.params.hasReplay);
    }
    return qs;
  }

  /**
   * Builds a standardized stack trace string from the frames in the given `stackInfo` object, with each frame separated
   * by a newline character. Lines take the form `<functionName>@<url>:<lineNumber>`.
   *
   * @param {StackInfo} stackInfo - An object specifying a stack string and individual frames.
   * @returns {string} A canonical stack string built from the URLs and function names in the given `stackInfo` object.
   */
  buildCanonicalStackString(stackInfo) {
    var canonicalStackString = '';
    for (var i = 0; i < stackInfo.frames.length; i++) {
      var frame = stackInfo.frames[i];
      var func = canonicalFunctionName(frame.func);
      if (canonicalStackString) canonicalStackString += '\n';
      if (func) canonicalStackString += func + '@';
      if (typeof frame.url === 'string') canonicalStackString += frame.url;
      if (frame.line) canonicalStackString += ':' + frame.line;
    }
    return canonicalStackString;
  }

  /**
   *
   * @param {Error|UncaughtError} err The error instance to be processed
   * @param {number} time the relative ms (to origin) timestamp of occurence
   * @param {boolean=} internal if the error was "caught" and deemed "internal" before reporting to the jserrors feature
   * @param {object=} customAttributes  any custom attributes to be included in the error payload
   * @param {boolean=} hasReplay a flag indicating if the error occurred during a replay session
   * @param {string=} swallowReason a string indicating pre-defined reason if swallowing the error.  Mainly used by the internal error SMs.
   * @returns
   */
  storeError(err, time, internal, customAttributes, hasReplay, swallowReason) {
    if (!err) return;
    // are we in an interaction
    time = time || (0,now/* now */.z)();
    let filterOutput;
    if (!internal && this.agentRef.runtime.onerror) {
      filterOutput = this.agentRef.runtime.onerror(err);
      if (filterOutput && !(typeof filterOutput.group === 'string' && filterOutput.group.length)) {
        // All truthy values mean don't report (store) the error, per backwards-compatible usage,
        // - EXCEPT if a fingerprinting label is returned, via an object with key of 'group' and value of non-empty string
        return;
      }
      // Again as with previous usage, all falsey values would include the error.
    }
    var stackInfo = computeStackTrace(err);
    const {
      shouldSwallow,
      reason
    } = evaluateInternalError(stackInfo, internal, swallowReason);
    if (shouldSwallow) {
      this.reportSupportabilityMetric('Internal/Error/' + reason);
      return;
    }
    var canonicalStackString = this.buildCanonicalStackString(stackInfo);
    const params = {
      stackHash: stringHashCode(canonicalStackString),
      exceptionClass: stackInfo.name,
      request_uri: runtime/* globalScope */._A?.location.pathname
    };
    if (stackInfo.message) params.message = '' + stackInfo.message;
    // Notice if filterOutput isn't false|undefined OR our specified object, this func would've returned already (so it's unnecessary to req-check group).
    // Do not modify the name ('errorGroup') of params without DEM approval!
    if (filterOutput?.group) params.errorGroup = filterOutput.group;
    if (hasReplay) params.hasReplay = hasReplay;
    /**
     * The bucketHash is different from the params.stackHash because the params.stackHash is based on the canonicalized
     * stack trace and is used downstream in NR1 to attempt to group the same errors across different browsers. However,
     * the canonical stack trace excludes items like the column number increasing the hit-rate of different errors potentially
     * bucketing and ultimately resulting in the loss of data in NR1.
     */
    var bucketHash = stringHashCode("".concat(stackInfo.name, "_").concat(stackInfo.message, "_").concat(stackInfo.stackString, "_").concat(params.hasReplay ? 1 : 0));
    if (!this.stackReported[bucketHash]) {
      this.stackReported[bucketHash] = true;
      params.stack_trace = truncateSize(stackInfo.stackString);
      this.observedAt[bucketHash] = Math.floor(this.agentRef.runtime.timeKeeper.correctRelativeTimestamp(time));
    } else {
      params.browser_stack_hash = stringHashCode(stackInfo.stackString);
    }
    params.releaseIds = (0,stringify/* stringify */.P)(this.agentRef.runtime.releaseIds);

    // When debugging stack canonicalization/hashing, uncomment these lines for
    // more output in the test logs
    // params.origStack = err.stack
    // params.canonicalStack = canonicalStack

    if (!this.pageviewReported[bucketHash]) {
      params.pageview = 1;
      this.pageviewReported[bucketHash] = true;
    }
    params.firstOccurrenceTimestamp = this.observedAt[bucketHash];
    params.timestamp = Math.floor(this.agentRef.runtime.timeKeeper.correctRelativeTimestamp(time));
    var type = 'err';
    var newMetrics = {
      time
    };

    // Trace sends the error in its payload, and both trace & replay simply listens for any error to occur.
    const jsErrorEvent = [type, bucketHash, params, newMetrics, customAttributes];
    (0,handle/* handle */.p)('trace-jserror', jsErrorEvent, undefined, features/* FEATURE_NAMES.sessionTrace */.DT.sessionTrace, this.ee);
    // still send EE events for other features such as above, but stop this one from aggregating internal data
    if (this.blocked) return;
    if (err?.__newrelic?.[this.agentIdentifier]) {
      params._interactionId = err.__newrelic[this.agentIdentifier].interactionId;
      params._interactionNodeId = err.__newrelic[this.agentIdentifier].interactionNodeId;
    }
    const softNavInUse = Boolean(this.agentRef.features?.[features/* FEATURE_NAMES.softNav */.DT.softNav]);
    // Note: the following are subject to potential race cond wherein if the other feature aren't fully initialized, it'll be treated as there being no associated interaction.
    // They each will also tack on their respective properties to the params object as part of the decision flow.
    if (softNavInUse) (0,handle/* handle */.p)('jserror', [params, time], undefined, features/* FEATURE_NAMES.softNav */.DT.softNav, this.ee);else (0,handle/* handle */.p)('spa-jserror', jsErrorEvent, undefined, features/* FEATURE_NAMES.spa */.DT.spa, this.ee);
    if (params.browserInteractionId && !params._softNavFinished) {
      // hold onto the error until the in-progress interaction is done, eithered saved or discarded
      this.bufferedErrorsUnderSpa[params.browserInteractionId] ??= [];
      this.bufferedErrorsUnderSpa[params.browserInteractionId].push(jsErrorEvent);
    } else if (params._interactionId != null) {
      // same as above, except tailored for the way old spa does it
      this.bufferedErrorsUnderSpa[params._interactionId] = this.bufferedErrorsUnderSpa[params._interactionId] || [];
      this.bufferedErrorsUnderSpa[params._interactionId].push(jsErrorEvent);
    } else {
      // Either there is no interaction (then all these params properties will be undefined) OR there's a related soft navigation that's already completed.
      // The old spa does not look up completed interactions at all, so there's no need to consider it.
      this.#storeJserrorForHarvest(jsErrorEvent, params.browserInteractionId !== undefined, params._softNavAttributes);
    }
  }
  #storeJserrorForHarvest(errorInfoArr, softNavOccurredFinished, softNavCustomAttrs = {}) {
    let [type, bucketHash, params, newMetrics, localAttrs] = errorInfoArr;
    const allCustomAttrs = {};
    if (softNavOccurredFinished) {
      Object.entries(softNavCustomAttrs).forEach(([k, v]) => setCustom(k, v)); // when an ixn finishes, it'll include stuff in jsAttributes + attrs specific to the ixn
      bucketHash += params.browserInteractionId;
      delete params._softNavAttributes; // cleanup temp properties from synchronous evaluation; this is harmless when async from soft nav (properties DNE)
      delete params._softNavFinished;
    } else {
      // interaction was cancelled -> error should not be associated OR there was no interaction
      Object.entries(this.agentRef.info.jsAttributes).forEach(([k, v]) => setCustom(k, v));
      delete params.browserInteractionId;
    }
    if (localAttrs) Object.entries(localAttrs).forEach(([k, v]) => setCustom(k, v)); // local custom attrs are applied in either case with the highest precedence

    const jsAttributesHash = stringHashCode((0,stringify/* stringify */.P)(allCustomAttrs));
    const aggregateHash = bucketHash + ':' + jsAttributesHash;
    this.events.add([type, aggregateHash, params, newMetrics, allCustomAttrs]);
    function setCustom(key, val) {
      allCustomAttrs[key] = val && typeof val === 'object' ? (0,stringify/* stringify */.P)(val) : val;
    }
  }

  // TO-DO: Remove this function when old spa is taken out. #storeJserrorForHarvest handles the work with the softnav feature.
  onInteractionDone(interaction, wasSaved) {
    if (!this.bufferedErrorsUnderSpa[interaction.id] || this.blocked) return;
    this.bufferedErrorsUnderSpa[interaction.id].forEach(item => {
      var allCustomAttrs = {};
      const localCustomAttrs = item[4];
      Object.entries(interaction.root.attrs.custom || {}).forEach(setCustom); // tack on custom attrs from the interaction
      Object.entries(localCustomAttrs || {}).forEach(setCustom);
      var params = item[2];
      if (wasSaved) {
        params.browserInteractionId = interaction.root.attrs.id;
        if (params._interactionNodeId) params.parentNodeId = params._interactionNodeId.toString();
      }
      delete params._interactionId;
      delete params._interactionNodeId;
      var hash = wasSaved ? item[1] + interaction.root.attrs.id : item[1];
      var jsAttributesHash = stringHashCode((0,stringify/* stringify */.P)(allCustomAttrs));
      var aggregateHash = hash + ':' + jsAttributesHash;
      this.events.add([item[0], aggregateHash, params, item[3], allCustomAttrs]);
      function setCustom([key, val]) {
        allCustomAttrs[key] = val && typeof val === 'object' ? (0,stringify/* stringify */.P)(val) : val;
      }
    });
    delete this.bufferedErrorsUnderSpa[interaction.id];
  }
  onSoftNavNotification(interactionId, wasFinished, softNavAttrs) {
    if (this.blocked) return;
    this.bufferedErrorsUnderSpa[interactionId]?.forEach(jsErrorEvent => this.#storeJserrorForHarvest(jsErrorEvent, wasFinished, softNavAttrs) // this should not modify the re-used softNavAttrs contents
    );
    delete this.bufferedErrorsUnderSpa[interactionId]; // wipe the list of jserrors so they aren't duplicated by another call to the same id
  }
}

/***/ })

}]);